import { CategoryRepository } from '@src/main/modules/parameters/domain/issues/category.repository';
import { createCategoryHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/CategoryHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useCategories = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<CategoryRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createCategoryHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await repository.findAll();
    },
    enabled: !!repository,
    staleTime: 1000 * 60 * 5,
  });

  return { ...queryResult, repository };
};
